import { required, minValue } from 'vuelidate/lib/validators';

export default {
  name: 'accum-act-modal',
  props: {
    show: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isLoading: false,
      total: 0,
      nonTaxable: 0,
      unrestrictedNonPreserve: 0,
      showWarning: false,
    };
  },
  computed: {
    getItem() {
      return this.$store.getters['toolkit/getItemData'];
    },
    accumulation() {
      return this.getItem.accumulation;
    },
    pensions() {
      return this.getItem.pensions;
    },
    accumStatus() {
      return this.accumulation.status;
    },
    isTransition() {
      return (
        this.getItem.requirements.eligibility.reasons
        === 'The pension will be a transition to retirement pension'
      );
    },
    nonTaxablePercent() {
      if (this.total === 0 || this.total === '') {
        return 1;
      }
      return this.nonTaxable / this.total;
    },
    taxable() {
      return parseFloat((this.total - this.nonTaxable).toFixed(2));
    },
    taxablePercent() {
      return 1 - this.nonTaxablePercent;
    },
  },
  methods: {
    handleClose() {
      this.$emit('close');
    },
    resetData() {
      this.total = 0;
      this.nonTaxable = 0;
      this.unrestrictedNonPreserve = 0;
    },
    async handleSave() {
      this.isLoading = true;
      const accumulation = {
        amount: this.total,
        unrestrictedNonPreserve: this.isTransition ? this.unrestrictedNonPreserve : undefined,
        components: {
          taxable: {
            value: this.taxable,
            percent: this.taxablePercent,
          },
          nonTaxable: {
            value: this.nonTaxable,
            percent: this.nonTaxablePercent,
          },
        },
        status: this.accumStatus === 'STARTED' ? 'IN_PROGRESS' : this.accumStatus,
      };

      const action = this.accumStatus === 'STARTED' && this.pensions.length === 0
        ? 'init-pension'
        : 'review-pension';

      await this.$store.dispatch('toolkit/updateItemKey', { data: { accumulation } });
      await this.$store.dispatch('toolkit/saveItem');
      this.resetData();
      this.isLoading = false;
      this.$emit('close', action);
    },
  },
  watch: {
    show: {
      immediate: true,
      handler() {
        this.total = this.accumulation.amount;
        this.nonTaxable = this.accumulation.components.nonTaxable.value;
        if (this.isTransition) {
          this.unrestrictedNonPreserve = this.accumulation.unrestrictedNonPreserve;
        }
      },
    },
    total: {
      immediate: true,
      handler(val) {
        this.showWarning = this.nonTaxable > 0 && this.nonTaxable === val;
      },
    },
    nonTaxable: {
      immediate: true,
      handler(val) {
        this.showWarning = val > 0 && this.total === val;
      },
    },
  },
  validations() {
    if (this.isTransition) {
      return {
        total: {
          required,
          minValue: minValue(1),
        },
        nonTaxable: {
          required,
          lessThanTotal: (value, vm) => +value <= vm.total,
        },
        unrestrictedNonPreserve: {
          required,
          lessThanTotal: (value, vm) => +value <= vm.total,
        },
      };
    }
    return {
      total: {
        required,
        minValue: minValue(1),
      },
      nonTaxable: {
        required,
        lessThanTotal: (value, vm) => +value <= vm.total,
      },
    };
  },
};
